
import { API } from "../config/api";

class OptionsService  {

    // Get the list of all the dropdown options ====================================================================================================

    /**
     * Get list of all dropdown options
     * @returns {array} - The list of all the dropdown options
    */
    getDropDownOptions() {
        const url = `/options/colletionAll`;

        return API.get(url);
    }


    // Get the list of states by country ====================================================================================================

    /**
     * Gets the list of states by country
     * @param {string} country - the id of the country
     * @returns {array} - Gets the list of states by country
    */
    getStatesByCountry(country) {
        const url = `/options/states?country_id=${country}`;

        return API.get(url);
    }

    
    // Get the list of cities by state ====================================================================================================

    /**
     * Get the list of cities by state
     * @param {string} state - the id of the state
     * @returns {array} - Get the list of cities by state
    */
    getCitiesByState(state) {
        const url = `/options/cities?state_id=${state}`;

        return API.get(url);
    }

     
    // Get the list of cities by country ====================================================================================================

    /**
     * Gets the list of cities by country
     * @param {string} country - the id of the country
     * @returns {array} - Gets the list of cities by country
    */
    getCitiesByCountry(country) {
        const url = `/options/cities?country_id=${country}`;

        return API.get(url);
    }

    
    // Get the list of municipalities by city ====================================================================================================

    /**
     * Gets the list of municipalities by city
     * @param {string} city - the id of the city
     * @returns {array} - Gets the list of municipalities by city
    */
    getMunicipalitiesByCity(city) {
        const url = `/options/municipalities?city_id=${city}`;

        return API.get(url);
    }

    
    // Get the list of municipalities by state ====================================================================================================

    /**
     * Gets the list of municipalities by state
     * @param {string} state - the id of the state
     * @returns {array} - Gets the list of municipalities by state
    */
    getMunicipalitiesByState(state) {
        const url = `/options/municipalities?state_id=${state}`;

        return API.get(url);
    }

    
    // Get the list of municipalities by parish ====================================================================================================

    /**
     * Gets the list of municipalities by parish
     * @param {string} parish - the id of the parish
     * @returns {array} - Gets the list of municipalities by parish
    */
    getMunicipalitiesByParish(parish) {
        const url = `/options/municipalities?parish_id=${parish}`;

        return API.get(url);
    }


    // Get the list of parishies by municipality ====================================================================================================

    /**
     * Gets the list of parishies by municipality
     * @param {string} municipality - the id of the municipality
     * @returns {array} - Gets the list of parishies by municipality
    */
    getParishiesByMunicipality(municipality) {
        const url = `/options/parishies?municipality_id=${municipality}`;

        return API.get(url);
    }


    // Get the list of parishies by state ====================================================================================================

    /**
     * Gets the list of parishies by state
     * @param {string} state - the id of the state
     * @returns {array} - Gets the list of parishies by state
    */
    getParishiesByState(state) {
        const url = `/options/parishies?state_id=${state}`;

        return API.get(url);
    }


    // Get the list of sectors by state ====================================================================================================

    /**
     * Gets the list of sectors by state
     * @param {string} state - the id of the state
     * @returns {array} - Gets the list of sectors by state
    */
    getSectorsByState(state) {
        const url = `/options/sectors?state_id=${state}`;

        return API.get(url);
    }

       
    // Get Phone Area Codes by state ====================================================================================================

    /**
     * Get Phone Area Codes by state
     * @param {string} state - the id of the state
     * @returns {array} - Get the list of phone area codes by state
    */
    getPhoneAreaCodesByState(state) {
        const url = `/options/areaCodes?state_id=${state}`;

        return API.get(url);
    }


    // Get the list of municipalities with offices by state ====================================================================================================

    /**
     * Get the list of municipalities with offices by state
     * @param {string} state - the id of the state
     * @returns {array} - Gets the list of municipalities with offices
    */
    getMunicipaltiesWithOfficesByState(state) {
        const url = `/options/municipalitiesThatHaveOffices?state_id=${state}`;

        return API.get(url);
    }    


    // Get the list of offices by municipality ====================================================================================================

    /**
     * Gets the list of offices by municipality
     * @param {string} municipality - the id of the municipality
     * @returns {array} - Gets the list of offices by municipality
    */
    getOfficesByMunicipality(municipality) {
        const url = `/options/offices?municipality_id=${municipality}`;

        return API.get(url);
    }

}

export default new OptionsService();